import { Axios } from "../../Api/axios";
import { clean } from "../Withdrawals/payoutParts";

// Withdrawal KYC (national ID) review — backend: Admin\Users\AdminUsersController.
//
//   GET  Admin-users?exchangeStatus=review|allowed|not_allowed&name=&page=&limit=
//        → Laravel resource collection {data:[{id,name,nick_name,img,followers,
//          created_at (unix), isCanExchange, kyc_front_url, kyc_back_url}],
//          links, meta:{current_page,last_page,per_page,total}}
//        `name` = users.name OR nick_name (LIKE) OR the exact id ("123" /
//        "#123"); users with a NULL name are left out. kyc_*_url: short-lived
//        signed links (15 min) of the national-ID images, else the stored URL,
//        null when not uploaded (2026-10-22).
//   POST Admin-users/update-exchange-status {id, isCanExchange: allowed|not_allowed|review}
//        → {message, user} (422 on any other value, 404 unknown user).
//
// The app sets `review` when the user uploads the national ID front/back
// (users.front_card_image / back_card_image). WithdrawalService refuses a
// new withdrawal unless isCanExchange = 'allowed' (config withdraw.require_kyc);
// requests already in the queue are not touched by a change here.
// Older backends send no kyc_*_url: the page then shows "Not sent by the API".

export const KYC_TABS = [
  { key: "review", label: "Waiting for review" },
  { key: "allowed", label: "Allowed" },
  { key: "not_allowed", label: "Not allowed" },
];

export const KYC_ACTIONS = [
  { key: "allowed", label: "Allow", tone: "success" },
  { key: "not_allowed", label: "Not allowed", tone: "danger" },
  { key: "review", label: "Back to review", tone: "ghost" },
];

export const listKycUsers = ({ status, name, page, limit }) =>
  Axios.get("/Admin-users", { params: clean({ exchangeStatus: status, name, page, limit }) }).then((r) => r.data);

export const setKycStatus = (id, isCanExchange) =>
  Axios.post("/Admin-users/update-exchange-status", { id, isCanExchange }).then((r) => r.data);
